import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import fullSound from "./components/full-sound";
import contributions from "./components/contributions";
import simulation from "./components/simulation";

const principle: Slide = {
  description:
    "The basic principle behind BTPA is to measure and analyze the different transfer paths between the different sources of sound and the ears of the listener (represented by a binaural measurement system). For complex systems, with different possible sources, paths, and operating points, a large number of measurements are usually required.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Full sound" }, { name: "Contributions (Analysis)" }, { name: "Simulation" }],
        },
      ],
      controlsPosition: "top",
      extraContent: [[], [], []],
      components: [fullSound, contributions, simulation],
    },
  },
};

export default principle;
